
define('text!templates/modules/questionnaire/responses/answers/answer-list-item.html',[],function () { return '<div class="info-section"></div>\n';});

